import React, { Fragment, useContext, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { Container, Row, Col, Card, CardBody, Form, FormGroup, Label } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { Btn } from '../../../AbstractElements';
import { toast } from "react-toastify";
import axios from 'axios';
import config from '../../../config';

const DeleteData = () => {

    const deletePermission = localStorage.getItem("dataDeletePermission")
    const login_id = localStorage.getItem("loginId");
    const loginName = localStorage.getItem("loginName");

    if (deletePermission !== 'true') {
        alert('You are not authorized to view this page');
        window.history.back();
    }

    const token = localStorage.getItem("sessiontoken");
    const configheader = {
        headers: {
            Authorization: token
        }
    };



    const [concessionaires, setConcessionaires] = useState([])
    const [selectedConcessionaire, setSelectedConcessionaire] = useState()
    const [tenantCode, setTenantCode] = useState()
    const [fromDate, setFromDate] = useState()
    const [toDate, setToDate] = useState()
    const [reason, setReason] = useState()
    const [tenantDetails, setTenantDetails] = useState()
    const [modalOpen, setModalOpen] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);

    const toggleModal = (e) => {
        if (e) e.preventDefault();

        const start = new Date(fromDate);
        const end = new Date(toDate);


        const diffDays = (end - start) / (1000 * 60 * 60 * 24);

        if (diffDays < 0) {
            toast.error("To Date cannot be earlier than From Date");
            return;
        }

        if (diffDays > 31) {
            toast.error("Maximum 1 month data can be deleted at a time");
            return;
        }
        setModalOpen(!modalOpen)
    };


    useEffect(() => {
        axios
            .post(`${config.hostname}/users/getconcessionaireaccess`, { user_id: login_id }, configheader)
            .then((response) => {
                setConcessionaires(response.data.concessionaire_access);
            })
            .catch((error) => {
                console.log(error);
            });
    }, [])

    const getTeantDetails = () => {

        axios
            .post(`${config.hostname}/tenant/gettenantbytcode`, {
                concessionaire_id: selectedConcessionaire,
                tenant_code: tenantCode
            }, configheader)
            .then((response) => {
                setTenantDetails(response.data)
            })
            .catch((error) => {
                setTenantDetails()
                console.log(error);
            });
    }

    const handleConcessionaireChange = (e) => {
        e.preventDefault();
        setSelectedConcessionaire(e.target.value)
        setTenantCode('')
        setTenantDetails()
    }

    const handleTCodeChange = (e) => {
        e.preventDefault();
        const value = e.target.value
        setTenantCode(value)
        if (value === '') {
            setTenantDetails()
        }
    }

    const handleDelete = (e) => {


        axios
            .post(`${config.hostname}/salesTransactions/delete`, {
                concessionaire_id: selectedConcessionaire,
                tcode: tenantCode,
                start_date: fromDate,
                end_date: toDate,
                reason: reason,
                created_by: loginName
            }, configheader)
            .then((response) => {
                toast.success('Data has been deleted')
                setSelectedConcessionaire()
                setTenantCode()
                setFromDate()
                setToDate()
                setReason()
                setTenantDetails()
            })
            .catch((error) => {
                console.log(error);
                toast.error(error.message)
            });
    }

    return (
        <Row>
            <Col sm='12'>
                <Card>
                    <CardBody>
                        <Form className='theme-form' onSubmit={toggleModal} >
                            <Fragment>
                                <Row>
                                    <Col>
                                        <FormGroup>
                                            <Label>Concessionaire</Label>
                                            <select name="country" id="propertycountry" className="form-control digits" required
                                                value={selectedConcessionaire}
                                                onChange={handleConcessionaireChange}
                                            >
                                                <option value="">Select Concessionaire</option>
                                                {concessionaires.map(concessionaire => (
                                                    <option key={concessionaire._id} value={concessionaire._id}>{concessionaire.concessionaire_name}</option>
                                                ))}
                                            </select>
                                        </FormGroup>
                                    </Col>
                                    <Col>
                                        <FormGroup>
                                            <Label>Tenant Code</Label>
                                            <input className="form-control" type="text" name="tcode" placeholder="Tenant code"
                                                value={tenantCode} onChange={handleTCodeChange}
                                                onBlur={getTeantDetails}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault();
                                                        getTeantDetails();
                                                    }
                                                }} required
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <FormGroup>
                                            <Label>From Date</Label>
                                            <input className="form-control" type="date" name="fdate"
                                                value={fromDate} onChange={(e) => setFromDate(e.target.value)} required
                                                max={new Date().toISOString().split("T")[0]}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col>
                                        <FormGroup>
                                            <Label>To Date</Label>
                                            <input className="form-control" type="date" name="tdate"
                                                value={toDate} onChange={(e) => setToDate(e.target.value)} required
                                                max={new Date().toISOString().split("T")[0]}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <FormGroup>
                                            <Label>Tenant Details</Label>
                                            <textarea
                                                className="form-control"
                                                name="details"
                                                rows="4"
                                                value={
                                                    tenantDetails
                                                        ? `Store Name: ${tenantDetails.tenant_store_name || ""}\nMall Code: ${tenantDetails.tenant_mall_code || ""}\nUnit Code: ${tenantDetails.tenant_unit_code || ""}`
                                                        : ""
                                                }
                                                readOnly
                                                required
                                            ></textarea>
                                        </FormGroup>
                                    </Col>
                                    <Col>
                                        <FormGroup>
                                            <Label>Reason</Label>
                                            <textarea
                                                className="form-control"
                                                name="reason"
                                                placeholder="Enter Reason"
                                                rows="4"
                                                value={reason}
                                                onChange={(e) => setReason(e.target.value)}
                                                required
                                            ></textarea>
                                        </FormGroup>
                                    </Col>

                                </Row>

                            </Fragment>
                            <Row>
                                <Col>
                                    <div className='text-end'>
                                        <Btn attrBtn={{ color: 'primary', className: 'me-3', type: "submit" }}  >Delete </Btn>
                                        <Link to={`${process.env.PUBLIC_URL}/admin/home/:layout`}>
                                            <Btn attrBtn={{ color: 'danger' }}>Cancel</Btn>
                                        </Link>
                                    </div>
                                </Col>
                            </Row>

                        </Form>
                    </CardBody>
                </Card>
            </Col>
            <Modal isOpen={modalOpen} toggle={toggleModal} centered>
                <ModalHeader toggle={toggleModal}>Confirm Deletion</ModalHeader>
                <ModalBody>
                    <p>
                        <strong>Tenant Code:</strong> {tenantCode || ""}<br />
                        <strong>Store Name:</strong> {tenantDetails?.tenant_store_name || ""}<br />
                        <strong>Mall Code:</strong> {tenantDetails?.tenant_mall_code || ""}<br />
                        <strong>Date Range:</strong> {fromDate} - {toDate}<br /><br />
                        Are you sure you want to delete all data for this tenant within this date range?
                    </p>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggleModal}>
                        Cancel
                    </Button>
                    <Button
                        color="danger"
                        disabled={confirmLoading}
                        onClick={async () => {
                            setConfirmLoading(true);
                            try {
                                await handleDelete();
                                toggleModal();
                            } finally {
                                setConfirmLoading(false);
                            }
                        }}
                    >
                        {confirmLoading ? "Deleting..." : "Yes, Delete"}
                    </Button>
                </ModalFooter>
            </Modal>

        </Row>
    )
}

export default DeleteData